import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";  // Import useAuth for logout
import logo from "../assets/logo.png";
import "../../style/ConfirmPassword.css"; // Create this CSS file as needed

const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

const ConfirmPassword = () => {
    const navigate = useNavigate();
    const { logout } = useAuth(); // Get logout function
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        // Force logout immediately so the user is treated as unauthenticated
        logout();

        // Extract the token from the hash portion of the URL
        // Expected URL: "https://.../#/confirm-password?token=XYZ"
        const hash = window.location.hash; // e.g., "#/confirm-password?token=XYZ"
        let token = null;
        if (hash) {
            const trimmedHash = hash.substring(1); // remove the "#"
            const parts = trimmedHash.split("?");
            if (parts.length > 1) {
                const queryString = parts[1]; // "token=XYZ"
                const urlParams = new URLSearchParams(queryString);
                token = urlParams.get("token");
            }
        }

        if (!token) {
            setError("Invalid or missing confirmation token.");
            return;
        }

        // Call the backend endpoint to confirm the password change
        const confirmPassword = async () => {
            try {

                const response = await fetch(`${API_BASE_URL}/backend/api/Settings/confirm_password_change.php?token=${token}`);
                const text = await response.text();
                console.log("Raw confirm_password_change response:", text);
                const result = JSON.parse(text);

                if (result.status === "success") {
                    setMessage("Password updated successfully. Please log in again.");
                } else {
                    setError(result.message);
                }
            } catch (err) {
                console.error("Confirm Password Error:", err);
                setError("An error occurred. Please try again later.");
            }
        };

        confirmPassword();
    }, [logout, navigate]);

    return (
        <div className="confirm-password-container">
            <div className="confirm-password-box">
                <div className="logo-container">
                        <img src={logo} alt="LockedIn Logo" className="logo" />
                </div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                {message && (
                    <button 
                        className="redirect-btn" 
                        onClick={() => navigate("/login", { replace: true })}
                    >
                        Go to Login
                    </button>
                )}
            </div>
        </div>
    );
};

export default ConfirmPassword;